var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainContainer",style:(_vm.loginImage)},[_c('TopHeader',{attrs:{"pageTitle":_vm.pageHead}}),_c('div',{staticClass:"pageContainer shadow-lg rounded",attrs:{"fluid":"sm"}},[_c('div',{staticClass:"page-content"},[_c('SecondaryHeader'),_c('DbTiles')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }